import React from 'react';
import { Box } from '@mui/material';
import './Loader.css';

const Loader = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      position: 'fixed',
      inset: 0,
      zIndex: 9999,
    }}
  >
    <span className="loader"></span>
  </Box>
);

export default Loader;
